
export interface StaticLoadState {
    selectedScheduleType: string;
    selectedPlanId: string;
    selectedDivision: string;
    weekStartDate: string;
    sourceDay: string;
    turnNumber: string;
}
  
export const initialState: StaticLoadState = {
    selectedScheduleType: "",
    selectedPlanId: "",
    selectedDivision: "1", // default division
    weekStartDate: "",
    sourceDay: "",
    turnNumber: ""
};
  